import React from "react";
import { v3 } from "@/lib/theme";

export function V3SectionHead({ kicker, title, sub, dimWord, alignRight }: any) {
  return (
    <div style={{ marginBottom: 56, display: "flex", justifyContent: alignRight ? "space-between" : "flex-start", alignItems: "flex-end", gap: 32, flexWrap: "wrap" }}>
      <div>
        <div style={{ font: `12px ${v3.mono}`, marginBottom: 14, display: "flex", alignItems: "center", gap: 12 }}>
          <span style={{ width: 24, height: 1, background: v3.accent, flex: "0 0 24px" }} />
          <span style={{ color: v3.accent, letterSpacing: "0.08em", textTransform: "uppercase" }}>{kicker}</span>
        </div>
        <h2 style={{ font: `500 64px/1 ${v3.sans}`, color: v3.fg, margin: 0, letterSpacing: "-0.035em", maxWidth: 1100 }} className="rp-h2">
          {dimWord ? (<>{title} <span style={{ color: v3.dim }}>{dimWord}</span></>) : title}
        </h2>
        {sub && <div style={{ font: `15px ${v3.sans}`, color: v3.dim, marginTop: 14, maxWidth: 640 }}>{sub}</div>}
      </div>
    </div>
  );
}
